import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _styled from "styled-components";
import React, { useMemo } from "react";
import { useRegistersSubscription } from "../../DeviceData/useRegistersSubscription";
import { useSetRegisterMutation } from "../../DeviceData/useSetRegisterMutation";
import { useRegisterConfigQuery } from "../../DeviceData/useRegisterConfigQuery";
import { EnumInput } from "../../controls/EnumInput";
import { formatDecimalNumber } from "../../controls/utils";
import { ToggledButton } from "../../ToggledButton/ToggledButton";

var Container = _styled.div.withConfig({
  displayName: "ControlScreen__Container",
  componentId: "he350y-0"
})(["flex:1;display:flex;flex-direction:column;height:0;"]);

var Title = _styled.div.withConfig({
  displayName: "ControlScreen__Title",
  componentId: "he350y-1"
})(["text-align:center;margin-bottom:20px;font-size:20px;"]);

var ParamsContainer = _styled.div.withConfig({
  displayName: "ControlScreen__ParamsContainer",
  componentId: "he350y-2"
})(["margin-top:40px;overflow-y:auto;background:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%) 0 100%,radial-gradient(50% 0,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)),radial-gradient(50% 100%,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)) 0 100%;background:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%) 0 100%,radial-gradient(farthest-side at 50% 0,rgba(0,0,0,0.2),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,rgba(0,0,0,0.2),rgba(0,0,0,0)) 0 100%;background-repeat:no-repeat;background-color:white;background-size:100% 40px,100% 40px,100% 14px,100% 14px;background-attachment:local,local,scroll,scroll;"]);

var SysAlarm = _styled.div.withConfig({
  displayName: "ControlScreen__SysAlarm",
  componentId: "he350y-3"
})(["display:flex;justify-content:center;align-items:center;margin-bottom:20px;font-size:20px;color:", ";opacity:", ";"], function (p) {
  return p.error ? "#dd4e4e" : "#333333";
}, function (p) {
  return p.indeterminate ? "0.33" : "1";
});

var SysAlarmIndicator = _styled.div.withConfig({
  displayName: "ControlScreen__SysAlarmIndicator",
  componentId: "he350y-4"
})(["width:16px;height:16px;border-radius:50%;margin-right:8px;background-color:", ";"], function (p) {
  return p.error ? "#dd4e4e" : "#4d9adf";
});

var ModesSection = _styled.div.withConfig({
  displayName: "ControlScreen__ModesSection",
  componentId: "he350y-5"
})(["padding:0 20px;"]);

var ModesGrid = _styled.div.withConfig({
  displayName: "ControlScreen__ModesGrid",
  componentId: "he350y-6"
})(["display:flex;flex-wrap:wrap;justify-content:center;margin:0 -10px;"]);

var ModesGridCell = _styled.div.withConfig({
  displayName: "ControlScreen__ModesGridCell",
  componentId: "he350y-7"
})(["flex:1 1 50%;box-sizing:border-box;padding:0 10px 20px;display:flex;"]);

var ModeButton = _styled.button.withConfig({
  displayName: "ControlScreen__ModeButton",
  componentId: "he350y-8"
})(["flex:1;border:0 none;border-radius:10px;padding:12px 10px;background-color:", ";color:", ";opacity:", ";font-size:20px;&:focus{outline:0 none;}"], function (p) {
  return p.active ? "#4d9ade" : "#edeeef";
}, function (p) {
  return p.active ? "white" : "#333333";
}, function (p) {
  return p.indeterminate ? "0.33" : "1";
});

var OutputStates = _styled.div.withConfig({
  displayName: "ControlScreen__OutputStates",
  componentId: "he350y-9"
})(["padding:0 20px;max-width:360px;box-sizing:border-box;margin:0 auto 20px;"]);

var OutputStatesGrid = _styled.div.withConfig({
  displayName: "ControlScreen__OutputStatesGrid",
  componentId: "he350y-10"
})(["display:flex;flex-wrap:wrap;align-items:center;justify-content:;gap:20px 40px;"]);

var AnalogOutputStates = _styled.div.withConfig({
  displayName: "ControlScreen__AnalogOutputStates",
  componentId: "he350y-11"
})(["padding:0 10px;box-sizing:border-box;margin:0 auto 20px;max-width:360px;"]);

var AnalogOutRow = _styled.div.withConfig({
  displayName: "ControlScreen__AnalogOutRow",
  componentId: "he350y-12"
})(["display:flex;align-items:center;margin-bottom:20px;justify-content:center;"]);

var AnalogOutLabel = _styled.div.withConfig({
  displayName: "ControlScreen__AnalogOutLabel",
  componentId: "he350y-13"
})(["flex:1;font-size:18px;"]);

var AnalogOutValue = _styled.div.withConfig({
  displayName: "ControlScreen__AnalogOutValue",
  componentId: "he350y-14"
})(["margin-left:16px;text-align:right;min-width:45px;font-size:18px;"]);

var Indicator = _styled.div.withConfig({
  displayName: "ControlScreen__Indicator",
  componentId: "he350y-15"
})(["flex:0 0 auto;border-radius:50%;width:50px;height:50px;background-color:", ";color:", ";opacity:", ";font-size:20px;display:flex;align-items:center;justify-content:center;"], function (p) {
  return p.active ? "#4d9ade" : "#edeeef";
}, function (p) {
  return p.active ? "white" : "#333333";
}, function (p) {
  return p.indeterminate ? "0.33" : "1";
});

var Indicator2 = _styled.div.withConfig({
  displayName: "ControlScreen__Indicator2",
  componentId: "he350y-16"
})(["flex:0 0 auto;border-radius:50%;width:50px;height:50px;background-color:", ";color:", ";opacity:", ";font-size:20px;display:flex;align-items:center;justify-content:center;"], function (p) {
  switch (p.color) {
    case "blue":
      return "#4d9ade";

    case "red":
      return "#dd4e4e";

    default:
      return "#edeeef";
  }
}, function (p) {
  switch (p.color) {
    case "blue":
      return "white";

    case "red":
      return "white";

    default:
      return "#333333";
  }
}, function (p) {
  return p.indeterminate ? "0.33" : "1";
});

var ActivationSection = _styled.div.withConfig({
  displayName: "ControlScreen__ActivationSection",
  componentId: "he350y-17"
})(["padding:0 10px;box-sizing:border-box;margin:0 auto 20px;max-width:360px;display:flex;justify-content:center;flex-wrap:wrap;gap:20px 0;"]);

var ActivationSwitchControl = _styled.div.withConfig({
  displayName: "ControlScreen__ActivationSwitchControl",
  componentId: "he350y-18"
})(["flex:0 1 33.33333%;display:flex;justify-content:center;align-items:center;"]);

var ActivationSelectControl = _styled.div.withConfig({
  displayName: "ControlScreen__ActivationSelectControl",
  componentId: "he350y-19"
})(["flex:0 1 100%;display:flex;justify-content:center;align-items:center;"]);

var ActivationTitle = _styled.div.withConfig({
  displayName: "ControlScreen__ActivationTitle",
  componentId: "he350y-20"
})(["margin-right:8px;min-width:25px;text-align:right;"]);

var ActivationSelectRow = _styled.div.withConfig({
  displayName: "ControlScreen__ActivationSelectRow",
  componentId: "he350y-21"
})(["text-align:center;"]);

function getAllRegisters(generalSection) {
  var modeRegs = generalSection.modes && generalSection.modes.triggers.map(function (trigger) {
    return trigger.register;
  });
  var outputRegs = generalSection.outputs && generalSection.outputs.registers.map(function (reg) {
    return reg.register;
  });
  var indicatorRegs = generalSection.indicators && generalSection.indicators.flatMap(function (indicator) {
    return indicator.registers.map(function (reg) {
      return reg.register;
    });
  });
  var analogOutputRegs = generalSection.analogOutputs && generalSection.analogOutputs.registers.map(function (reg) {
    return reg.register;
  });
  var sectionRegs = generalSection.activateSections && generalSection.activateSections.map(function (section) {
    return section.registers.map(function (reg) {
      return reg.register;
    });
  }).flat();
  return [generalSection.state && generalSection.state.register, generalSection["switch"] && generalSection["switch"].register].concat(_toConsumableArray(modeRegs || []), _toConsumableArray(indicatorRegs || []), _toConsumableArray(outputRegs || []), _toConsumableArray(analogOutputRegs || []), _toConsumableArray(sectionRegs || [])).filter(function (reg) {
    return !!reg;
  });
}

export function ControlScreen(_ref) {
  var serviceMenu = _ref.serviceMenu;
  var generalSection = serviceMenu.general;
  var allRegisters = useMemo(function () {
    return getAllRegisters(generalSection);
  }, [generalSection]);

  var _useRegistersSubscrip = useRegistersSubscription(allRegisters),
      registersData = _useRegistersSubscrip.registersData;

  var registerConfig = useRegisterConfigQuery(allRegisters);

  var _useSetRegisterMutati = useSetRegisterMutation(),
      _useSetRegisterMutati2 = _slicedToArray(_useSetRegisterMutati, 1),
      setRegister = _useSetRegisterMutati2[0];

  if (!registerConfig) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ParamsContainer, null, function () {
    if (!generalSection.state) {
      return;
    }

    var register = generalSection.state.register;
    var config = register && registerConfig[register];
    var value = register && registersData[register];

    if (!config) {
      return;
    }

    return /*#__PURE__*/React.createElement(SysAlarm, {
      error: value >= 1,
      indeterminate: value === undefined
    }, value !== undefined && /*#__PURE__*/React.createElement(SysAlarmIndicator, {
      error: value >= 1
    }), value >= 0 ? config["enum"][registersData.sysAlarm] : config.title);
  }(), function () {
    if (!generalSection["switch"]) {
      return;
    }

    var register = generalSection["switch"].register;
    var config = register && registerConfig[register];
    var value = register && registersData[register];

    if (!config || config.type !== "BOOL" && config.type !== "COIL") {
      return;
    }

    return /*#__PURE__*/React.createElement(ActivationSection, null, /*#__PURE__*/React.createElement(ActivationSwitchControl, {
      key: register
    }, /*#__PURE__*/React.createElement(ActivationTitle, null, config.title), /*#__PURE__*/React.createElement(ToggledButton, {
      on: !!value,
      indeterminate: value === undefined,
      onChange: function onChange() {
        if (config.type === "COIL") {
          setRegister(register, !value);
        } else {
          setRegister(register, 1 - value);
        }
      }
    })));
  }(), generalSection.modes && generalSection.modes.triggers.length > 0 && /*#__PURE__*/React.createElement(ModesSection, null, /*#__PURE__*/React.createElement(ModesGrid, null, generalSection.modes.triggers.map(function (trigger) {
    var register = trigger.register;
    var config = register && registerConfig[register];
    var value = register && registersData[register];

    if (!config) {
      return;
    }

    return /*#__PURE__*/React.createElement(ModesGridCell, {
      key: register
    }, /*#__PURE__*/React.createElement(ModeButton, {
      active: value,
      indeterminate: value === undefined,
      onClick: value === 0 ? function () {
        return setRegister(register, 1);
      } : undefined
    }, config.title));
  }))), generalSection.indicators && generalSection.indicators.map(function (indicatorSection, idx) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: idx
    }, /*#__PURE__*/React.createElement(Title, null, indicatorSection.title), /*#__PURE__*/React.createElement(OutputStates, null, /*#__PURE__*/React.createElement(OutputStatesGrid, null, indicatorSection.registers.map(function (indicator) {
      var register = indicator.register;
      var config = register && registerConfig[register];
      var value = register && registersData[register];

      if (!config) {
        return;
      }

      var color = "grey";

      if (value !== undefined) {
        var strValue = value.toString();

        if (config.type === "ENUM") {
          strValue = config["enum"][value];
        }

        if (!indicator.colors) {
          color = indicator.defaultColor || (!!value ? "blue" : "grey");
        } else {
          color = indicator.colors[strValue] || indicator.defaultColor || "grey";
        }
      }

      return /*#__PURE__*/React.createElement(Indicator2, {
        key: register,
        indeterminate: value === undefined,
        color: color
      }, indicator.title || "");
    }))));
  }), (generalSection.outputs || generalSection.analogOutputs) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, null, "\u0421\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u0432\u044B\u0445\u043E\u0434\u043E\u0432"), generalSection.outputs && /*#__PURE__*/React.createElement(OutputStates, null, /*#__PURE__*/React.createElement(OutputStatesGrid, null, generalSection.outputs.registers.map(function (reg) {
    var register = reg.register;
    var config = register && registerConfig[register];
    var value = register && registersData[register];

    if (!config) {
      return;
    }

    return /*#__PURE__*/React.createElement(Indicator, {
      key: register,
      indeterminate: value === undefined,
      active: value
    }, config.title);
  }))), generalSection.analogOutputs && /*#__PURE__*/React.createElement(AnalogOutputStates, null, generalSection.analogOutputs.registers.map(function (reg) {
    var register = reg.register;
    var config = register && registerConfig[register];
    var value = register && registersData[register];

    if (!config) {
      return;
    }

    return /*#__PURE__*/React.createElement(AnalogOutRow, {
      key: register
    }, /*#__PURE__*/React.createElement(AnalogOutLabel, null, config.title), /*#__PURE__*/React.createElement(AnalogOutValue, null, value != null ? formatDecimalNumber(value, config.decimals) : "--", config.unit ? " ".concat(config.unit) : undefined));
  }))), generalSection.activateSections && generalSection.activateSections.map(function (actSection, idx) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: idx
    }, /*#__PURE__*/React.createElement(Title, null, actSection.title), /*#__PURE__*/React.createElement(ActivationSection, null, actSection.registers.map(function (reg) {
      var register = reg.register;
      var config = register && registerConfig[register];
      var value = register && registersData[register];

      if (!config) {
        return;
      }

      if (config.type === "BOOL") {
        return /*#__PURE__*/React.createElement(ActivationSwitchControl, {
          key: register
        }, /*#__PURE__*/React.createElement(ActivationTitle, null, config.title), /*#__PURE__*/React.createElement(ToggledButton, {
          on: value === 1,
          indeterminate: value === undefined,
          onChange: function onChange() {
            setRegister(register, 1 - value);
          }
        }));
      }

      if (config.type === "ENUM") {
        return /*#__PURE__*/React.createElement(ActivationSelectControl, {
          key: register
        }, /*#__PURE__*/React.createElement(EnumInput, {
          value: value,
          title: config.title,
          valuesEnum: config["enum"],
          onChange: function onChange(value) {
            return setRegister(register, +value);
          }
        }, function (_ref2) {
          var onClick = _ref2.onClick;
          return /*#__PURE__*/React.createElement(ActivationSelectRow, {
            onClick: onClick
          }, config.title, " - ", value !== undefined && config["enum"][value]);
        }));
      }

      return null;
    })));
  })));
}